import styled from 'styled-components';

import { addFocusStyle } from '../../lib/mixins';
import { pxToRem } from '../../lib/utils';

export const StyledAnchor = styled.a`
  display: block;
  padding: ${pxToRem(11)} ${pxToRem(20)} ${pxToRem(15)};
  text-decoration: none;

  &:focus {
    ${addFocusStyle()}
    border-radius: ${pxToRem(3)};
  }
`;

export const StyledImage = styled.img`
  display: block;
  height: ${pxToRem(25)};
  width: auto;
`;
